import styled, { css } from "styled-components";

export const Container = styled.div`
  display: flex;
`;